/** Pure layout math for StatCard value fitting (unit-testable without Pixi canvas). */

export function primaryValueFontPx(cardW: number, cardH: number): number {
  const fromWidth = cardW * 0.06;
  let size = Math.round(Math.max(22, Math.min(30, fromWidth)));
  if (cardW <= 320) size = Math.round(Math.max(18, Math.min(20, fromWidth)));
  else if (cardW < 375) size = Math.round(Math.max(20, Math.min(26, fromWidth)));
  if (cardH <= 40) size = Math.min(size, Math.max(14, Math.floor(cardH * 0.52)));
  return size;
}

export function statCardValueBand(cardH: number, captionFontPx: number): {
  top: number;
  bottom: number;
  height: number;
  centerY: number;
} {
  const padTop = Math.max(2, cardH * 0.1);
  const padBottom = Math.max(2, cardH * 0.1);
  const gap = Math.max(1, cardH * 0.04);
  const captionH = captionFontPx * 1.15;
  const top = padTop + captionH + gap;
  const bottom = cardH - padBottom;
  const height = Math.max(8, bottom - top);
  return { top, bottom, height, centerY: top + height / 2 };
}

/** Estimates whether a balance string fits using monospace-ish width heuristic. */
export function estimateBalanceFits(
  cardW: number,
  cardH: number,
  valueText: string,
  padX = Math.max(4, cardW * 0.06),
): { fontPx: number; fits: boolean } {
  const captionFontPx = Math.round(Math.max(11, Math.min(14, cardH * 0.2)));
  const band = statCardValueBand(cardH, captionFontPx);
  const maxW = Math.max(8, cardW - padX * 2);
  const minSize = Math.max(11, Math.floor(band.height / 1.08));
  let fontPx = primaryValueFontPx(cardW, cardH);
  while (fontPx >= minSize) {
    const estW = valueText.length * fontPx * 0.58;
    const estH = fontPx * 1.05;
    if (estW <= maxW && estH <= band.height + 0.5) return { fontPx, fits: true };
    fontPx -= 1;
  }
  const estW = valueText.length * minSize * 0.58;
  const estH = minSize * 1.05;
  return { fontPx: minSize, fits: estW <= maxW && estH <= band.height + 0.5 };
}
